import "vue-tsx-support/enable-check"
import {VNode} from 'vue'
import * as tsx from "vue-tsx-support";
import './cellRenderTsx.less'
export interface CellRenderTsxpStatesI {
	cellRender(h,params): any
}

const CellRenderTsx = tsx.componentFactory.create({

	data() {
		return {
			cellData: '',
		}
	},

	render (h): VNode {
		let cellRendererFrameworkOpt:CellRenderTsxpStatesI = (this.params.colDef.cellRendererFrameworkOpt) as CellRenderTsxpStatesI
		return (
			<div class="wqms-table-tooltip">{cellRendererFrameworkOpt.cellRender(h,this.params)}</div>
		)
	}
})
export default CellRenderTsx
